const state = {
  showPinchIn: false,    // 画面表示
  pinchInParams: {},    // 表示パラメータ
  pinchInAudioPlayActIndex: null,   // 音声再生パラメータ
}

const getters = {
  showPinchIn(state) {
    return state.showPinchIn
  },
  pinchInParams(state) {
    return state.pinchInParams
  },
  pinchInAudioPlayActIndex(state) {
    return state.pinchInAudioPlayActIndex
  }
}

const actions = {
  initPinchInAct({commit}) {
    commit('setPinchInParams', null)
    commit('setShowPinchIn', false)
  },
  showPinchIn({commit}, pinchInParams) {
    commit('setPinchInParams', pinchInParams)
    commit('setShowPinchIn', true)
  },
  hidePinchIn({commit}) {
    commit('setShowPinchIn', false)
  },
  setPinchInAudioPlayActIndex({commit}, pinchInAudioPlayActIndex) {
    commit('setPinchInAudioPlayActIndex', pinchInAudioPlayActIndex)
  },
}

const mutations = {
  setShowPinchIn(state, showPinchIn) {
    state.showPinchIn = showPinchIn
  },
  setPinchInParams(state, pinchInParams) {
    state.pinchInParams = pinchInParams
  },
  setPinchInAudioPlayActIndex(state, pinchInAudioPlayActIndex) {
    state.pinchInAudioPlayActIndex = pinchInAudioPlayActIndex
  },
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/pinchInAct.js